module.exports = __webpack_public_path__ + "static/media/youtube.d4c47373.png";